import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import NofollowedPagesRow from '../NofollowedPagesRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class NofollowedPagesTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        indexingCategory: PropTypes.shape({
          countNofollowTypesNofollowedPages: PropTypes.arrayOf(
            PropTypes.shape({
              count: PropTypes.number,
              type: PropTypes.string
            })
          ),
          nofollowedPages: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const noFollowToggles = get(this.props.project, 'crawls.edges[0].node.countNofollowTypesNofollowedPages', [])
      .map(v => ({ identifier: v.type, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_nofollowed_page_url' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />

          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('nofollowTypeFilters', noFollowToggles)}
            checkedItems={this.props.filters.nofollowTypeFilters}
            groups={noFollowToggles}
            name='nofollowTypeFilters'
            label={<Translate content='crawler_nofollow_type' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='indexingCategory' section='nofollowedPages'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_nofollowed_page_url' size='5' />
            <Translate content='crawler_source_page_url' size='5' />
            <Translate content='crawler_nofollow_type' size='2' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={NofollowedPagesRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(NofollowedPagesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment NofollowedPagesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        nofollowTypeFilters: {type: "[String]", defaultValue: []}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              countNofollowTypesNofollowedPages(url: $url, sourceUrl: $sourceUrl) {
                type
                count
              }
              nofollowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, nofollowTypeFilters: $nofollowTypeFilters) {
                count
                edges {
                  node {
                    ...NofollowedPagesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query NofollowedPagesTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $nofollowTypeFilters: [String],
        $sourceUrl: TextFilters,
        $url: TextFilters) {,
        project (host: $host) {
          ...NofollowedPagesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            url: $url,
            sourceUrl: $sourceUrl,
            nofollowTypeFilters: $nofollowTypeFilters
          )
        }
      }
    `
);
